import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
  Collapse,
} from "reactstrap"
import Select from "react-select"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "./datatables.scss"
import CustomTable from "components/Table/Table"

export const Testimonials = () => {
  // ---------------------Collapse Start-------------------------
  const [faq1, setFaq1] = useState(false)
  // ---------------------Collapse End-------------------------

  const [Testimonials_Modal, setTestimonials_Modal] = useState(false)

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function AddTestimonials_Modal() {
    setTestimonials_Modal(!Testimonials_Modal)
    removeBodyCss()
  }

  const [selectedGroup, setselectedGroup] = useState(null)
  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    {
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
    },
  ]

  const [totalSize, setTotalSize] = useState(3)

  const data = {
    columns: [
      {
        text: "Testimonials Name",
        dataField: "TestimonialsName",
        style: { width: "21%" },
      },
      {
        text: "Testimonials",
        dataField: "Testimonials",
        style: { width: "41%" },
      },
      {
        text: "Image",
        dataField: "Image",
        style: { width: "8%", align: 'center' },
      },
      {
        text: "Status",
        dataField: "Status",
        style: { width: "13%" },
      },
    ],
    rows: [
      {
        TestimonialsName: "Nilesh Soni",
        Testimonials: "In promotion and advertising, a testimonial or show consists of a person's written or spoken statement extolling the virtue of a product.",
        Image: "",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-lightionStatust btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddTestimonials_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        TestimonialsName: "Nilesh Soni",
        Testimonials: "In promotion and advertising, a testimonial or show consists of a person's written or spoken statement extolling the virtue of a product.",
        Image: "",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-lightionStatust btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddTestimonials_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        TestimonialsName: "Nilesh Soni",
        Testimonials: "In promotion and advertising, a testimonial or show consists of a person's written or spoken statement extolling the virtue of a product.",
        Image: "",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-lightionStatust btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddTestimonials_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
    ],
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Testimonials List | Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Utility"
              breadcrumbItem="Testimonials List"
            />
            <Col sm={6}>
              <div className="float-end d-none d-md-block pt-2">
                <Button
                  color="primary"
                  className="btn btn-primary waves-effect waves-light mt-4"
                  onClick={() => {
                    AddTestimonials_Modal()
                  }}
                  data-toggle="modal"
                  data-target=".bs-example-modal-lg"
                >
                  Add Testimonials
                </Button>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="accordion mb-3" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button font-size-15 faq"
                      style={{
                        backgroundColor: "rgb(164, 229, 207)",
                        height: "40px",
                        color: "#000",
                      }}
                      type="button"
                      onClick={() => {
                        setFaq1(!faq1)
                      }}
                    >
                      <i class="fas fa-filter"></i> &nbsp;Filter Testimonials
                      List
                    </button>
                  </div>
                  <Collapse isOpen={faq1} className="accordion-collapse">
                    <div className="accordion-body">
                      <Row>
                        <Col lg="5">
                          <div className="mb-3">
                            <Label>Testimonials Name</Label>
                            <Input
                              type="text"
                              maxLength="25"
                              name="TestimonialsName"
                              id="TestimonialsName"
                            />
                          </div>
                        </Col>
                        
                        <Col lg="5">
                          <div className="mb-3">
                            <Label>Status</Label>
                            <Select
                              value={selectedGroup}
                              onChange={() => {
                                handleSelectGroup()
                              }}
                              options={optionGroup}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </Col>
                        <Col lg="2">
                          <div className="float-end d-none d-md-block pt-4">
                            <Button
                              color="primary"
                              className="btn btn-primary waves-effect waves-light mt-1"
                            >
                              Search
                            </Button>{" "}
                            <Button
                              color=""
                              className="btn btn-outline-primary mt-1"
                            >
                              Clear
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <MDBDataTable responsive bordered data={data} noBottomColumns/> */}
                  <CustomTable
                    keyField="candidateList"
                    columns={data.columns}
                    data={data.rows}
                    totalSize={totalSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal
        size="md"
        isOpen={Testimonials_Modal}
        toggle={() => {
          AddTestimonials_Modal()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Testimonials
          </h5>
          <button
            onClick={() => {
              AddTestimonials_Modal()
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <AvForm className="needs-validation">
            <Row>
              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    name="TestimonialsName"
                    label="Testimonials Name"
                    placeholder="Testimonials Name"
                    type="text"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField type="select" name="Status" label="Status">
                    <option>Active</option>
                    <option>Inactive</option>
                  </AvField>
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    name="Testimonials"
                    label="Testimonials"
                    placeholder="Testimonials..."
                    type="textarea"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    label="Testimonials Image"
                    name="TestimonialsImage"
                    type="file"
                    className="form-control"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button color="primary" className="mt-3" type="submit">
              Submit
            </Button>{" "}
            <Button
              color="outline-primary"
              className="mt-3"
              onClick={() => {
                AddTestimonials_Modal()
              }}
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </Button>
          </AvForm>
        </div>
      </Modal>
    </React.Fragment>
  )
}
